import TopicThree from "../../../components/market-contents/forex-market-contents/TopicThree";

const ForexMarketContentThree = () => {
  return (
    <>
      {/* Add the TopicOne component here */}
      {/* <TopicThree /> */}

      <div className="how__work__market">
        <div className="quality-section-market">
          <div className="quality-header-market">
            <h1>Why The Pips</h1>
            <p>
              Trade smarter with technology built for precision and performance.
            </p>
          </div>
        </div>
        <div className="container">
          <div className="contact__cards row">
            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Fastest Execution</h4>
                </div>
                <p>
                  Experience ultra-low latency and instant trade execution with
                  our advanced trading infrastructure.
                </p>
              </div>
            </div>

            {/* Email Inquiries */}
            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Transparent Pricing</h4>
                </div>
                <p>No hidden charges, what you see is what you trade.</p>
              </div>
            </div>

            {/* Our Office */}
            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>24/7 Support</h4>
                </div>
                <p>
                  Our multilingual support team is ready to assist you anytime.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* </section> */}
    </>
  );
};

export default ForexMarketContentThree;
